'use client';

import { useState } from 'react';

import { SaleApplicationStages } from './SaleApplicationStages';
import { SaleLoading } from './SaleLoading';
import { SaleSetupForm } from './sale-setup-form';
import { useSellerProfileQuery } from '@/features/original-sale';
import { useSaleSetupFormQuery } from '@/features/original-sale/hooks/use-sale-setup-form-query';

interface SaleTabContentProps {
  fanficId?: string;
}

export const SaleTabContent = ({ fanficId }: SaleTabContentProps) => {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const { profile, isLoading: isLoadingProfile } = useSellerProfileQuery();

  const shouldFetchPostSale = Boolean(
    fanficId && profile?.isVerifiedSeller && profile.status === 'completed',
  );
  const {
    data: postSaleData,
    isLoading: isLoadingPostSale,
    refetch,
  } = useSaleSetupFormQuery(fanficId, shouldFetchPostSale);

  if (isLoadingProfile || isLoadingPostSale) {
    return <SaleLoading />;
  }

  if (profile && profile.isVerifiedSeller && profile.status === 'completed') {
    return (
      <div className="max-w-[540px] mx-auto py-6">
        <SaleSetupForm
          postId={fanficId}
          initialPrice={postSaleData?.application?.price}
          initialFreeChaptersCount={postSaleData?.application?.freeChaptersCount}
          sellerRewardPercent={postSaleData?.sellerRewardPercent}
          applicationStatus={postSaleData?.application?.status}
          onSuccess={refetch}
        />
      </div>
    );
  }

  return (
    <SaleApplicationStages
      fanficId={fanficId}
      profile={profile}
      isSubmitted={isSubmitted}
      onSuccess={() => setIsSubmitted(true)}
    />
  );
};
